import React from "react";
import { Grid } from "react-flexbox-grid";

import * as styles from "./styles.module.css";

const Background = ({
  children,
  pattern = true,
  color = "gray",
  bottom = false,
  taller = false,
  containerClass = "",
}) => {
  const backgroundStyle = styles[color];
  const patternStyle = pattern ? styles.pattern : "";
  const bottomStyle = bottom ? styles.bottomVisible : "";
  const tallerStyle = taller ? styles.taller : "";
  return (
    <Grid
      fluid
      className={`${styles.container} ${backgroundStyle} ${patternStyle} ${bottomStyle}`}
    >
      <div className={`${styles.whiteBar} ${styles.top}`}></div>
      <Grid className={`${tallerStyle} ${containerClass}`}>{children}</Grid>
      {bottom ? (
        <div className={`${styles.whiteBar} ${styles.bottom}`}></div>
      ) : null}
    </Grid>
  );
};

export default Background;
